import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

export const collectionFieldToIcon = {
  earliestReadyTime: { icon: "E", colour: "#44A7DF" },
  latestReadyTime: { icon: "L", colour: "#84C546" },
  sameDayCutOff: { icon: "S", colour: "#DC0032" },
  lowerLevelAdjustments: { icon: "T", colour: "#000" },
  saturnAutotrue: {
    icon: <CheckIcon style={{ height: "12px", width: "12px" }} />,
    colour: "#E3AD1A",
  },
  saturnAutofalse: {
    icon: <CloseIcon style={{ height: "12px", width: "12px" }} />,
    colour: "#DC0032",
  },
};

export const PLANNED = "PLANNED";
export const SAME_DAY = "SAME_DAY";

export const COLLECTION_TAB_FOR_FIELD = {
  "Same Day": "sameDayRoute",
  Planned: "plannedRoute",
};

export const COLLECTION_TAB_FOR_TYPE = {
  "Same Day": SAME_DAY,
  Planned: PLANNED,
};

export const DEFAULT_COLLECTION_AREA = {
  earliestReadyTime: null,
  latestReadyTime: null,
  sameDayCutOff: null,
  saturnAuto: null,
  plannedRoute: null,
  sameDayRoute: null,
  defaultPlannedRoute: null,
  defaultSameDayRoute: null,
};

export const COLLECTION_FIELDS = [
  {
    text: "Same Day Cut-Off",
    depotValueKey: "defaultSameDayCutOff",
    valueKey: "sameDayCutOff",
    type: "text",
  },
  {
    text: "Earliest Ready Time",
    depotValueKey: "defaultEarliestReadyTime",
    valueKey: "earliestReadyTime",
    type: "text",
  },
  {
    text: "Latest Ready Time",
    depotValueKey: "defaultLatestReadyTime",
    valueKey: "latestReadyTime",
    type: "text",
  },
  {
    text: "Saturn Auto",
    depotValueKey: "defaultSaturnAuto",
    valueKey: "saturnAuto",
    type: "bool",
  },
];

export const DEFAULT_COLLECTION_TYPES = {
  PLANNED: {
    ROUTE_CODE_KEY: "plannedRoute",
    DEFAULT_ROUTE_CODE_KEY: "defaultPlannedRoute",
    DEFAULT_COLOUR_KEY: "defaultPlannedColour",
  },
  SAME_DAY: {
    ROUTE_CODE_KEY: "sameDayRoute",
    DEFAULT_ROUTE_CODE_KEY: "defaultSameDayRoute",
    DEFAULT_COLOUR_KEY: "defaultSameDayColour",
  },
};
